import React, { type FC } from 'react';
// TODO: JFP-2824 | Suppressed to enable upgrade to ESLint v9 - please fix this if you can!
// eslint-disable-next-line jira/restricted/@atlaskit+analytics-next
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { ANALYTIC_CONTEXTS } from '@atlassian/jira-servicedesk-common/src/utils/analytics/index.tsx';
import AuthenticationPanelWithBreadcrumbs, { type Props } from './view.tsx';

const AuthenticationPanelWithBreadcrumbsAndAnalytics: FC<Props> = (props: Props) => (
	<AnalyticsContext
		data={{
			attributes: {
				context: ANALYTIC_CONTEXTS.KNOWLEDGE,
			},
		}}
	>
		<AuthenticationPanelWithBreadcrumbs {...props} />
	</AnalyticsContext>
);

export default AuthenticationPanelWithBreadcrumbsAndAnalytics;
